import React, { useEffect, useRef } from 'react';

import { useComponentParamsContext } from 'lib/context/ComponentParamsContext/ComponentParamsContext';

import Button from 'components/shared/Button/Button';
import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';

const Input = ({ params, setEditing, autoFocus }) => {
  const { formik } = useComponentParamsContext();
  const inputRef = useRef(null);
  const allowedFields = ['allowable_amount_cents', 'adjustment_amount_cents'];

  useEffect(() => {
    if (autoFocus) inputRef.current?.focus();
  }, [autoFocus]);

  const updateField = (centsValue) => {
    const paySchedule = [...formik.values.paySchedule];
    const service_id = params.data.service_id;
    const payer_id = params.data.payer_id;
    const payScheduleIndex = paySchedule.findIndex(
      (schedule) => schedule.service_id === service_id && schedule.payer_id === payer_id
    );

    const field = params?.colDef?.field;

    const payerData = { service_id, payer_id };

    if (allowedFields.includes(field)) {
      payerData[field] = centsValue;
    }

    if (payScheduleIndex === -1) {
      paySchedule.push(payerData);
    } else {
      paySchedule[payScheduleIndex] = {
        ...paySchedule[payScheduleIndex],
        ...payerData
      };
    }

    formik.setFieldValue('paySchedule', paySchedule);
  };

  const onBlur = (value) => {
    const eventValue = typeof value === 'number' ? (value / 100).toFixed(2) : value || '0';
    const newValue = eventValue.replace('$', '').trim();
    const centsValue = !isNaN(newValue) ? Math.round(+newValue * 100) : null;

    updateField(centsValue);
    setEditing?.(false);
  };

  const handleClear = () => {
    updateField(null);
    setEditing?.(false);
  };

  return (
    <div className="flex h-full w-full items-center justify-between gap-1">
      <CurrencyInput
        ref={inputRef}
        value={params.value}
        variant="secondary"
        onBlur={onBlur}
        hideBorder
      />
      <Button
        icon="close-linear"
        size="xs"
        iconSize={14}
        color="neutral"
        variant="link"
        onClick={handleClear}
        className="mr-2 hover:opacity-70"
      />
    </div>
  );
};

export default Input;
